import jQuery from 'jquery';

window.$ = jQuery;
$(function () {
    //パスワードにフォーカスした際の処理
    $('.password__input').on('focus', function() {
        $(this).parent('.password-wrapper').addClass('focus');
    });

    //パスワードからフォーカスが外れた際の処理
    $('.password__input').on('blur', function() {
        $(this).parent('.password-wrapper').removeClass('focus');
    })

    //パスワード表示切替
    $('#password__toggle').on('click', (e) => {
        const target = $(e.currentTarget);
        target.toggleClass('focus');
        target.toggleClass('icon-view-hide');
        target.toggleClass('icon-view-show');

        const isPasswordVisible = target.hasClass('focus');

        if (isPasswordVisible) {
            // $eyeImg.attr('src', $currentImageSource.replace('eye.png', 'eye_close.png'));
            $('#password').attr('type', 'text');
        }
        else {
            // $eyeImg.attr('src', $currentImageSource.replace('eye_close.png', 'eye.png'));
            $('#password').attr('type', 'password');
        }
    })

    $('#password_confirmation__toggle').on('click', function() {
        var pass_type = $('#password_confirmation').attr('type')

        $(this).toggleClass('focus');

        if(pass_type === 'text')
        {
            $('#password_confirmation').attr('type', 'password');
        }
        else
        {
            $('#password_confirmation').attr('type', 'text');
        }
    })
});